import { apiRequest } from '../utils/useAPIRequest';
import { chargeStore, transactionStore } from '../stores';
import constant from '../utils/constant';


const getCharges = async (query = "") => {

	const { status, errorMessage, data } = await apiRequest({
		url: '/charges/all-charges',
		method: 'get',
	});
	if (status === constant.Success) {
		const { charges } = data || {};
		chargeStore.setCharges(charges);
		return { status }
	}
	return { status, errorMessage };
};

const createCharge = async payload => {
	const { status, errorMessage, data } = await apiRequest({
		url: '/charges/charge',
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		await Promise.all([
			getCharges(),
		]);
		return { status: constant.Success, data };
	}
	return { errorMessage, status, data };
};
const editCharge = async (payload, id) => {
	const { status, errorMessage, data } = await apiRequest({
		url: `/charges/update/${id}`,
		method: 'patch',
		payload,
	});
	if (status === constant.Success) {
		await Promise.all([
			getCharges(),
		]);
		return { status: constant.Success, data };
	}
	return { errorMessage, status, data };
};

const deleteCharge = async (id) => {
	const { status, errorMessage } = await apiRequest({
		url: `/charges/charge/${id}`,
		method: 'delete',
	});
	if (status === constant.Success) {
		await getCharges();
		return { status };
	}
	return { status, errorMessage };
}


export default {
	getCharges,
	createCharge,
	editCharge,
	deleteCharge,
};
